import { render, staticRenderFns } from "./listpurchases.vue?vue&type=template&id=7a12ab9f&scoped=true"
import script from "./listpurchases.vue?vue&type=script&lang=js"
export * from "./listpurchases.vue?vue&type=script&lang=js"
import style0 from "./listpurchases.vue?vue&type=style&index=0&id=7a12ab9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a12ab9f",
  null
  
)

export default component.exports